/** Shared types for Navigation sub-components */

export interface NavLinkItem {
  to: string;
  label: string;
}

export const NAV_LINKS: NavLinkItem[] = [
  { to: '/', label: 'Home' },
  { to: '/programs', label: 'Programs' },
  { to: '/monthly-app', label: 'Monthly App' },
  { to: '/nutrition-programs', label: 'Nutrition Programs' },
  { to: '/shop', label: 'Shop' },
  { to: '/community', label: 'Community' },
  { to: '/blog', label: 'Blog' },
];
